import React, { useEffect } from 'react';
import { unarchiveJob, archiveJob } from '../api';
import './jobmodal.css'; // Importing the CSS for styling
import JobOrder from './joborder';

const JobModal = ({ showModal, toggleModal, job, onJobUpdated, onCopyJob }) => {
  // Add/remove class to App when modal opens/closes
  useEffect(() => {
    const appElement = document.querySelector('.App');
    if (showModal) {
      appElement?.classList.add('joborder-open');
    } else {
      appElement?.classList.remove('joborder-open');
    }
    
    // Cleanup on unmount
    return () => {
      appElement?.classList.remove('joborder-open');
    };
  }, [showModal]);

  if (!showModal) {
    return null;
  }

  const handleJobUpdate = (updatedJob) => {
    console.log('=== JOB MODAL - handleJobUpdate ===');
    console.log('Updated job:', updatedJob);

    if (onJobUpdated && updatedJob) {
      onJobUpdated(updatedJob);
    }
    toggleModal();
  };


  const handleArchive = async (jobId) => {
    try {
      if (job.is_archived) {
        await unarchiveJob(jobId);
        if (onJobUpdated) {
          onJobUpdated({ ...job, is_archived: false });
        }
      } else {
        await archiveJob(jobId);
        if (onJobUpdated) {
          onJobUpdated({ ...job, is_archived: true });
        }
      }
      toggleModal();
    } catch (error) {
      console.error('Error archiving/unarchiving job:', error);
    }
  };

  const handleClose = (updatedJob) => {
    if (updatedJob === null) {
      // User chose to leave without saving - just close the modal without updating
      toggleModal();
    } else if (updatedJob) {
      handleJobUpdate(updatedJob);
    } else {
      toggleModal();
    }
  };

  return (
    <div className="jobmodal-overlay">
      <div className="jobmodal-content">
        {job && <JobOrder
          job={job}
          onClose={handleClose}
          onArchiveJob={handleArchive}
          onCopyJob={onCopyJob}
        />}
      </div>
    </div>
  );
};

export default JobModal;